import man1 from '@/assets/reviews/man1.png';
import man2 from '@/assets/reviews/man2.png';
import man3 from '@/assets/reviews/rahul_new.png';
import man4 from '@/assets/reviews/man4.png';
import woman1 from '@/assets/reviews/woman1.png';
import woman2 from '@/assets/reviews/woman2.png';

export interface Review {
  author_name: string;
  author_url?: string;
  language?: string;
  profile_photo_url: string;
  rating: number;
  relative_time_description: string;
  text: string;
  time: number;
}

export const mockReviews: Review[] = [
  {
    author_name: "pachus creation07",
    profile_photo_url: man1,
    rating: 5,
    relative_time_description: "3 days ago",
    text: "Nice service friendly driver affordable charges 💗💗💗",
    time: 1767504000
  },
  {
    author_name: "shabeeb shebi",
    profile_photo_url: man2,
    rating: 5,
    relative_time_description: "13 weeks ago",
    text: "I had a wonderful experience with this taxi service, booking was very easy and the fare was very reasonable, i highly recommend this taxi service to anyone looking for safe and comfortable transportation.",
    time: 1760000000
  },
  {
    author_name: "Rahul K.",
    profile_photo_url: man3,
    rating: 5,
    relative_time_description: "a week ago",
    text: "Excellent service! The driver was very professional and the car was clean. Highly recommended for family trips in Kerala.",
    time: 1709251200
  },
  {
    author_name: "Sarah Jenkins",
    profile_photo_url: woman1,
    rating: 5,
    relative_time_description: "2 weeks ago",
    text: "We booked a 5-day tour package. It was an amazing experience. The itinerary was well planned and executed perfectly.",
    time: 1708646400
  },
  {
    author_name: "Mohammed F.",
    profile_photo_url: man4,
    rating: 5,
    relative_time_description: "a month ago",
    text: "Very punctual and reliable taxi service. Friends On Road Cab made our airport transfer seamless.",
    time: 1707523200
  },
  {
    author_name: "Anita George",
    profile_photo_url: woman2,
    rating: 4,
    relative_time_description: "2 months ago",
    text: "Great experience overall. The driver was knowledgeable about the local spots which was a huge plus.",
    time: 1704844800
  }
];

